import { handleActions } from 'redux-actions';
import * as licenseeAction from '../../actions/licensee/licenseeActions';

let initialState = {
  info: null,
  loading: false,
  errorMessage: '',
  updateSuccess: null,
};

export const licensee = handleActions(
  {
    [licenseeAction.getCompanyInfo]: (state, action) => {
      return { ...state, loading: true };
    },
    [licenseeAction.getCompanyInfoSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        info: payload,
        loading: false,
      };
    },
    [licenseeAction.getCompanyInfoFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false,
      };
    },
    [licenseeAction.updateCompanyInfo]: (state, action) => {
      return { ...state, loading: true };
    },
    [licenseeAction.updateCompanyInfoSuccess]: (state, action) => {        
      return {
        ...state,
        loading: false,
        errorMessage: null,
        info: {
          ...action.payload,
        },
        updateSuccess: state.updateSuccess ? state.updateSuccess + 1 : 1,
      };
    },
    [licenseeAction.updateCompanyInfoFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false,
      };
    },
  },
  initialState
);
